const Comparison = {
  parts: [
    'container',
    'heading',
    'selectionControls',
    'dropdownWrapper',
    'dropdown',
    'table',
    'row',
    'column',
    'divider',
    'productImage',
    'productInfo',
    'productName',
    'productPrice',
    'badge',
    'badgeText',
    'rowLabel',
    'featureTitle',
    'featureSubtext',
    'iconGroup',
    'coverIcon',
    'coverInfo',
    'sizeGroup',
    'sizeCircle',
    'sizeIcon',
    'sizeText',
    'availabilityInfo',
    'availabilityIcon',
    'availabilityText',
    'shopButton',
    'shopButtonText',
    'shopButtonArrow'
  ],
  baseStyle: {
    container: {
      display: 'flex',
      width: 'full',
      maxWidth: '1440px',
      mx: 'auto',
      py: {base: 14, md: 20}, // 56px mobile, 80px desktop
      px: {base: 3.75, md: 35}, // 20px mobile, 140px desktop
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: {base: 8, md: 10}, // 32px mobile, 40px desktop
      bg: 'brandColors.primaryBG', // #F7F5F0
    },
    heading: {
      color: 'brandColors.extraDarkCharcoal',
      textAlign: 'center',
      fontFamily: 'heading',
      fontSize: {base: '2xl', md: '4xl'}, // 24px mobile, 32px desktop
      fontWeight: 'normal',
      lineHeight: '120%',
      mb: 0,
      alignSelf: 'center',
    },
    selectionControls: {
      display: {base: 'flex', md: 'none'},
      width: 'full',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2.5,
    },
    dropdownWrapper: {
      flex: '1 1 calc(50% - 5px)',
      width: 'calc(50% - 5px)',
    },
    dropdown: {
      height: 14,
      borderRadius: '5px',
      border: '1px solid',
      borderColor: 'brandColors.paleGrey',
      bg: 'brandColors.primaryBG',
      color: 'brandColors.extraDarkCharcoal',
      fontFamily: 'heading',
      width: 'full',
      fontSize: 'sm',
      fontWeight: 'bold',
      lineHeight: 'normal',
      letterSpacing: 'normal',
    },
    table: {
      display: 'flex',
      width: 'full',
      flexDirection: 'column',
      alignItems: {base: 'center', md: 'flex-start'},
      gap: {base: 6, md: 7}, // 24px mobile, 28px desktop
    },
    row: {
      display: 'flex',
      alignItems: {base: 'flex-start', md: 'center'},
      gap: {base: 2.5, md: 5}, // 10px mobile, 20px desktop
      alignSelf: 'stretch',
      justifyContent: {base: 'center', md: 'center'},
      flexWrap: {base: 'wrap', md: 'nowrap'},
    },
    column: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: {base: 2, md: 4}, // 8px mobile, 16px desktop
      flex: {base: '1 1 calc(50% - 5px)', md: '1 0 0'},
      maxW: {base: 'calc(50% - 5px)', md: 'none'},
      width: {base: 'calc(50% - 5px)', md: 'auto'},
    },
    columnButton: {
      gap: {base: 6, md: 6},
    },
    divider: {
      width: 'full',
      height: '1px',
      bg: 'brandColors.greys',
    },
    productImage: {
      maxW: {base: '120px', md: '240px'}, // 120px mobile, 240px desktop
      objectFit: 'cover',
      marginX: 'auto',
    },
    productInfo: {
      display: 'flex',
      w: 'full',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 1, // 4px
      textAlign: 'center',
    },
    productName: {
      alignSelf: 'stretch',
      color: 'brandColors.extraDarkCharcoal',
      textAlign: 'center',
      fontFamily: 'heading',
      fontSize: {base: 'lg', md: 'xl'}, // 18px mobile, 20px desktop
      fontWeight: 'normal',
      lineHeight: '120%',
    },
    productPrice: {
      alignSelf: 'stretch',
      color: 'brandColors.extraDarkCharcoal',
      textAlign: 'center',
      fontFamily: 'body',
      fontSize: {base: 'xs', md: 'sm'}, // 12px mobile, 14px desktop
      fontWeight: 'normal',
      lineHeight: '20px',
    },
    badge: {
      display: 'flex',
      py: {base: 1, md: '5px'}, // 4px mobile, 5px desktop
      px: {base: 2, md: '10px'}, // 8px mobile, 10px desktop
      justifyContent: 'center',
      alignItems: 'center',
      gap: 2.5, // 10px
      borderRadius: '6px',
      border: '1px solid',
      borderColor: 'brandColors.darkCharcoal',
    },
    badgeText: {
      color: 'brandColors.darkCharcoal',
      textAlign: 'center',
      fontFamily: 'heading',
      fontSize: {base: 'xs', md: 'sm'}, // 12px mobile, 14px desktop
      fontWeight: 'medium',
      lineHeight: 'normal',
    },
    rowLabel: {
      alignSelf: 'stretch',
      color: 'brandColors.charcoal',
      textAlign: 'center',
      fontFamily: 'body',
      fontSize: {base: 'xs', md: 'sm'}, // 12px mobile, 14px desktop
      fontWeight: 'normal',
      lineHeight: '20px',
    },
    featureTitle: {
      alignSelf: 'stretch',
      color: {base: 'brandColors.extraDarkCharcoal', md: 'brandColors.darkCharcoal'},
      textAlign: 'center',
      fontFamily: 'heading',
      fontSize: {base: '15px', md: 'md'},
      fontWeight: 'medium',
      lineHeight: '120%',
    },
    featureSubtext: {
      alignSelf: 'stretch',
      color: 'brandColors.charcoal',
      textAlign: 'center',
      fontFamily: 'body',
      fontSize: {base: 'xs', md: 'sm'}, // 12px mobile, 14px desktop
      fontWeight: 'normal',
      lineHeight: '20px',
    },
    iconGroup: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: {base: 3, md: 4}, // 12px mobile, 16px desktop
    },
    coverIcon: {
      width: {base: 5, md: 7}, // 20px mobile, 28px desktop
      height: {base: 5, md: 7},
      flexShrink: 0,
      color: 'brandColors.darkCharcoal',
    },
    coverInfo: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 1, // 4px
      alignSelf: 'stretch',
    },
    sizeGroup: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      gap: {base: 1.5, md: 2}, // 6px mobile, 8px desktop
      flexWrap: 'wrap',
    },
    sizeCircle: {
      width: {base: 6, md: 8}, // 24px mobile, 32px desktop
      height: {base: 6, md: 8},
      flexShrink: 0,
      position: 'relative',
    },
    sizeIcon: {
      width: {base: 6, md: 8}, // 24px mobile, 32px desktop
      height: {base: 6, md: 8},
      flexShrink: 0,
      color: 'brandColors.darkCharcoal',
      position: 'absolute',
      top: 0,
      left: 0,
    },
    sizeText: {
      color: 'brandColors.darkCharcoal',
      textAlign: 'center',
      fontFamily: 'heading',
      fontSize: {base: 'sm', md: 'md'}, // 14px mobile, 16px desktop
      fontWeight: 'medium',
      lineHeight: 'normal',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    },
    availabilityInfo: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: {base: 1, md: 2}, // 4px mobile, 8px desktop
      alignSelf: 'stretch',
    },
    availabilityIcon: {
      width: {base: 8, md: 12}, // 32px mobile, 48px desktop
      height: {base: 8, md: 12},
      color: 'brandColors.darkCharcoal',
    },
    availabilityText: {
      alignSelf: 'stretch',
      color: 'brandColors.extraDarkCharcoal',
      textAlign: 'center',
      fontFamily: 'heading',
      fontSize: {base: 'sm', md: 'md'}, // 14px mobile, 15px desktop
      fontWeight: 'medium',
      lineHeight: '120%',
    },
    shopButton: {
      display: 'flex',
      width: {base: 37.5, md: 37.5},
      height: {base: 8, md: 8},
      py: {base: '9px', md: '9px'},
      px: {base: 6, md: 9}, // 24px mobile, 36px desktop
      justifyContent: 'center',
      alignItems: 'center',
      borderRadius: '5px',
      bg: 'brandColors.extraDarkCharcoal',
      cursor: 'pointer',
      transition: 'all 0.2s ease',
      _hover: {
        bg: 'brandColors.darkCharcoal',
      },
      _active: {
        bg: 'black',
      },
    },
    shopButtonText: {
      color: 'white',
      textAlign: 'center',
      fontFamily: 'heading',
      fontSize: '11px',
      fontWeight: 'bold',
      lineHeight: '14px',
      letterSpacing: {base: '0.88px', md: '0.88px'},
      textTransform: 'uppercase',
    },
    shopButtonArrow: {
      width: {base: 1.5, md: 2.5},
      height: {base: 1.5, md: 2.5},
      flexShrink: 0,
      ml: 1.5, // 6px
      color: 'white',
      sx: {
        svg: {
          width: 'full',
          height: 'full',
          stroke: 'currentColor',
        },
      },
    },
  },
};

export default Comparison;
